import { render, staticRenderFns } from "./IconSVG.vue?vue&type=template&id=c4676a40"
import script from "./IconSVG.vue?vue&type=script&lang=js"
export * from "./IconSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports